import cartState from './cartState';
import * as cartDataLogic from '../../../logic/api/cart';
import {
  getPartialSettings,
  setPartialSettingsToSessionStorage,
  removePartialSettingsFromSessionStorage
} from '../../../logic/api/userData';
import {isAuthenticated} from '../../../logic/authHelpers';
import {fetchPartialUserDataSuccess} from '../../User/redux/userAction';
import _ from 'lodash';

export const changeToCartItemQuantity = (toCartNewQuantity) => ({
  type: 'CART:CHANGE-ITEM-QUANTITY',
  toCartNewQuantity
});

export const getCartCount = () => (dispatch) => {
  dispatch({
    type: 'CART:GET-CART-COUNT'
  });
  if (isAuthenticated()) {
    dispatch(multipleCreateCart());
    getPartialSettings()
      .then((res) => {
        if (res.error)
          dispatch(multipleCreateCartError(res.err));
        else {
          if (!res.loaded) {
            //fetch once
            res.loaded = true;
            setPartialSettingsToSessionStorage(res);
          }
          dispatch(getCartCountSuccess(res.CartCount));
          dispatch(fetchPartialUserDataSuccess(res));
        }
      })
      .catch((err) => multipleCreateCartError(err));
  } else {
    dispatch(getCart());
  }
};
const getCartCountSuccess = (data) => ({
  type: 'CART:GET-CART-COUNT-SUCCESS',
  cartItemsCount: data
});


export const getCart = () => dispatch => {
  dispatch({
    type: 'CART:GET-CART'
  });

  cartDataLogic.getCart()
    .then((res) => {
      if (res.error)
        dispatch(getCartError(res.err));
      else {
        //#219
        if (isAuthenticated()) {
          getPartialSettings()
            .then((st) => {
              if (st.CartCount !== res.length) {
                st.CartCount = res.length;
                setPartialSettingsToSessionStorage(st);
              }
            });
        }
        dispatch(getCartSuccess(res));
      }

    })
    .catch((err) => {
      dispatch(getCartError(err));
    });
};
const getCartSuccess = (data) => ({
  type: 'CART:GET-CART-SUCCESS',
  cartItems: data
});
const getCartError = (err) => ({
  type: 'CART:GET-CART-ERROR',
  err
});


export const multipleCreateCart = () => dispatch => {
  const cartFromStorage = cartDataLogic.getCartFromLocaleStorage();
  if (cartFromStorage) {
    dispatch({
      type: 'CART:MULTIPLE-CREATE-CART'
    });
    let cartArray = cartFromStorage.map(cartDetail => {
      cartDetail.cartId = 0;
      return cartDetail;
    });
    cartDataLogic.multipleCreateCart(cartArray)
      .then((res) => {
        if (res.error)
          dispatch(multipleCreateCartError(res.err));
        else {
          dispatch(multipleCreateCartSuccess());

          cartDataLogic.removeCartFromLocaleStorage();
          dispatch(getCart());
        }
      })
      .catch((err) => multipleCreateCartError(err));
  }
};
const multipleCreateCartSuccess = () => ({
  type: 'CART:MULTIPLE-CREATE-CART-SUCCESS',
});
const multipleCreateCartError = (err) => ({
  type: 'CART:MULTIPLE-CREATE-CART-ERROR',
  err
});

export const updateCart = (cart) => (dispatch) => {
  dispatch({
    type: 'CART:UPDATE-CART'
  });

  cartDataLogic.updateCart(cart)
    .then((res) => {
      if (res.error)
        dispatch(updateCartError(res.err));
      else {
        if (isAuthenticated()) {
          getPartialSettings()
            .then((res) => {
              res.CartCount++;
              setPartialSettingsToSessionStorage(res);
              dispatch(getCart());
            })
            .catch((err) => dispatch(updateCartError(err)));


        } else {
          dispatch(getCart());
        }

      }
    })
    .catch((err) => dispatch(updateCartError(err)));
};
const updateCartError = (err) => ({
  type: 'CART:UPDATE-CART-ERROR',
  err
});


export const removeCartItem = (cartItemId) => (dispatch, getState) => {
  dispatch({
    type: 'CART:ITEM-REMOVE'
  });

  let cartItems = getState().cart2Reducer.cartItems;

  cartDataLogic.deleteCartItem(cartItemId, cartItems)
    .then(() => {
      dispatch(onCartRemoveSuccess(cartItemId, cartItems));
      getPartialSettings()
        .then((res) => {
          res.CartCount--;
          setPartialSettingsToSessionStorage(res);
          dispatch(getCart());
        })
        .catch((err) => dispatch(onCartRemoveError(err)));
    })
    .catch((err) => dispatch(onCartRemoveError(err)));
};

const onCartRemoveSuccess = (cartId, cartItems) => ({
  type: 'CART:ITEM-REMOVE-SUCCESS',
  cartItems: cartDataLogic.removeCartItemsFromState(cartId, cartItems)
});

const onCartRemoveError = (err) => ({
  type: 'CART:ITEM-REMOVE-ERROR',
  err
});


export const changeItemComment = (CartDetailId, comment) =>
  (dispatch, getState) => {
    dispatch({
      type: 'CART:COMMENT-CHANGE'
    });

    const text = comment['comment'];
    let cartItems = getState().cart2Reducer.cartItems;

    cartDataLogic.changeCartProperty({text}, CartDetailId, cartItems)
      .then(
        (res) => {
          if (res.error) {
            return dispatch(onCartChangeCommentError(res.error));
          }
          dispatch(onCartChangeCommentSuccess(text, CartDetailId));
        })
      .catch((err) => dispatch(onCartChangeCommentError(err)));

  };

const onCartChangeCommentSuccess = (CartDetailId, {text}) => ({
  type: 'CART:CHANGE-ITEM-COMMENT-SUCCESS',
  CartDetailId,
  text
});

const onCartChangeCommentError = (err) => ({
  type: 'CART:CHANGE-ITEM-COMMENT-ERR',
  err
});


export const changeCartItemQuantity = (newQuantity, cartDetailId) =>
  (dispatch, getState) => {
    dispatch({
      type: 'CART:CHANGE-ITEM-QUANTITY'
    });

    let cartItems = getState().cart2Reducer.cartItems;
    cartDataLogic.changeCartProperty({newQuantity}, cartDetailId, cartItems)
      .then(
        (res) => {
          if (res.error) {
            return dispatch(onCartChangeQuantityError(res.error));
          }

          dispatch(onCartChangeQuantitySuccess(newQuantity, cartDetailId));

        })
      .catch((err) => dispatch(onCartChangeQuantityError(err)));
  };

const onCartChangeQuantitySuccess = (newQuantity, cartId) => ({
  type: 'CART:CHANGE-ITEM-QUANTITY-SUCCESS',
  newQuantity,
  cartId
});

const onCartChangeQuantityError = (err) => ({
  type: 'CART:CHANGE-ITEM-QUANTITY-ERR',
  err
});

export const checkout = (id) => (dispatch) => {
  dispatch({
    type: 'CART:CHECKOUT'
  });
  cartDataLogic.checkout(id)
    .then((res) => {
      if (res.error) {
        if (res.error === 'Insufficient funds')
          return dispatch(checkoutSuccess('noFunds'));

        return dispatch(checkoutError(res.error));
      }
      if (res === false)
        return dispatch(getCart());

      removePartialSettingsFromSessionStorage(); // clear partial settings
      dispatch(checkoutSuccess(res));

    })
    .catch((err) => dispatch(checkoutError(err)));
};

const checkoutSuccess = (result) => ({
  type: 'CART:CHECKOUT-SUCCESS',
  result
});
const checkoutError = (err) => ({
  type: 'CART:CHECKOUT-ERROR',
  err
});

export const checkoutReset = () => dispatch => {
  dispatch({
    type: 'CART:CHECKOUT-RESET'
  });
};

export default function cart2Reducer(state = cartState, action) {
  switch (action.type) {
    case 'CART:GET-CART-COUNT-SUCCESS':
      return {
        ...state,
        cartItemsCount: action.cartItemsCount
      };
    case 'CART:GET-CART-SUCCESS':
      return {
        ...state,
        cartItems: action.cartItems,
        cartItemsCount: action.cartItems.length,
        thanks: false
      };
    case 'CART:CHANGE-ITEM-QUANTITY':
      return {
        ...state,
        toCartQuantity: action.toCartNewQuantity
      };
    case 'CART:ITEM-REMOVE-SUCCESS':
      return {
        ...state,
        cartItems: action.cartItems
        ,
        cartItemsCount: action.cartItems.length,
      };

    case 'CART:CHANGE-ITEM-QUANTITY-SUCCESS': {
      const index = _.findIndex(state.cartItems, {cartId: action.cartId});
      return {
        ...state,
        cartItems: [
          ...state.cartItems.slice(0, index),
          {
            ...state.cartItems[index],
            quantity: action.newQuantity
          },
          ...state.cartItems.slice(index + 1)
        ]
      };
    }
    case 'CART:COMMENT-CHANGE-SUCCESS':
      return {
        ...state,
        cartItems: _.reduce(state.cartItems, (res, el) => {
          if (el.CartDetailId === action.CartDetailId) {
            return [
              ...res,
              {
                ...el,
                Comment: action.text
              }
            ];
          }
          return [...res, el];
        }, [])
      };
    case 'CART:CHECKOUT-RESET':
      return {
        ...state,
        thanks: false
      };
    case 'CART:CHECKOUT-SUCCESS':
      return {
        ...state,
        thanks: action.result
      };
    case 'CART:RESULTS-ERROR':
    case 'CART:ITEM-REMOVE-ERROR':
    case 'CART:CREATE-CART-ERROR':
    case 'CART:GET-CART-ERROR':
    case 'CART:MULTIPLE-CREATE-CART-ERROR':
    case 'CART:CHECKOUT-ERROR':
      return {
        ...state,
        Error: action.err
      };

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Cart/redux/cartActions.js
 **/